import Splide from '@splidejs/splide';
import { debounce } from '../helpers/debounce';
import { nodeListToArray } from '../helpers/nodeListToArray';

export class LandingCarousels {
    landingCarouselContainers: HTMLElement[];
    triggers: HTMLElement[];
    activateSplides() {
        this.landingCarouselContainers.forEach(carouselContainer => {
            const splideContainer = carouselContainer.querySelector('[data-landingcarousel-splide-container]') as HTMLElement;
            const secondarySplide = carouselContainer.querySelector('[data-landingcarousel-splide-secondary]') as HTMLElement;
            const primarySplide = carouselContainer.querySelector('[data-landingcarousel-splide]') as HTMLElement;
            const triggers = nodeListToArray(document.querySelectorAll('[data-modal-trigger]'));
            var secondarySlider = new Splide(secondarySplide, {
                pagination: false,
                arrows: false,
                autoWidth: true,
                drag: false,
                gap: '1.25rem',
                breakpoints: {
                    1024: {
                        padding: {
                            right: '20%',
                            left: '0',
                        },
                        drag: true
                    },
                }
            }).mount();

            var primarySlider = new Splide(primarySplide, {
                type: 'loop',
                height: 656,
                pagination: true,
                arrows: false,
                autoplay: true,
                interval: 4000,
            });

            primarySlider.on('mounted', () => {
                splideContainer.appendChild(carouselContainer.querySelector('.splide__pagination'));
            });


            primarySlider.sync(secondarySlider).mount();

            const resizeWatcher = debounce(() => {
                this.updateSlideIndex(primarySlider);
                this.handleAutoplay(primarySlider);

            }, 50);

            this.handleAutoplay(primarySlider);
            this.triggerListener(primarySlider, triggers);
            window.addEventListener('resize', resizeWatcher);

            primarySlider.on('move', function () {
                if (window.matchMedia("(max-width: 1024px)").matches) {
                    primarySlider.Components.Autoplay.pause();
                }
            });

        });
    }
    constructor(landingCarouselContainers: HTMLElement[]) {
        this.landingCarouselContainers = landingCarouselContainers;
        this.activateSplides();

    }

    updateSlideIndex(slider) {
        const currentIndex = slider.index;
        slider.go(currentIndex)
    }
    handleAutoplay(slider) {
        if (window.matchMedia("(max-width: 1024px)").matches) {
            slider.Components.Autoplay.pause();
        }
    }
    triggerListener(slider, triggers) {
        // For each video modal trigger, pause on trigger press
        triggers.forEach((trigger) => {
            trigger.addEventListener('click', () => {
                slider.Components.Autoplay.pause();

                setTimeout(() => {
                    this.closeListener(slider);
                }, 1000)
            })
        })
    }
    closeListener(slider) {
        // If modal is clicked on, resume autoplay and remove listener
        if (document.querySelector('.modal')) {
            let el = document.querySelector('.modal.show');
            el.addEventListener('click', () => {
                if (!window.matchMedia("(max-width: 1024px)").matches) {
                    slider.Components.Autoplay.play();
                }
            }, { once: true })
        }
    }
}
